import { defaultApiState } from '@/store/types/general.types';
import { EventLogsState } from './types/event-logs.types';

export const eventLogsState: EventLogsState = {
  apiState: {
    getRecentEventLogs: defaultApiState
  },
  recentEventLogs: undefined
};
